export default __webpack_public_path__ + "static/media/swiftstrikes3.24892c76.png";